module.exports = __webpack_public_path__ + "static/media/google-large.6b57c5bb.svg";